import { useParams } from 'react-router-dom';
import { RegisterWithInvitation } from '../account/RegisterWithInvitation';

function RegisterWithInvitationWrapper() {
    const { guid } = useParams();
    return <RegisterWithInvitation guid={guid || ''} />;
}

export default RegisterWithInvitationWrapper;
